// Tema "Pulse" (2026-07): encabezado de página con gradiente indigo de marca,
// de ANCHO COMPLETO (mismo estilo que el banner de Cash Flow). Antes usaba
// márgenes negativos frágiles que lo dejaban angosto según el contenedor.
const PageHeader = ({ title, subtitle, breadcrumb, actions }) => {
  return (
    <div
      className="w-full text-white px-6 py-5 mb-6 rounded-xl shadow-card flex items-center justify-between"
      style={{ background: 'linear-gradient(120deg, #1B1740 0%, #35306B 55%, #4B44D6 130%)' }}
    >
      <div>
        <p className="text-xs text-[#B9B4FF] font-semibold uppercase tracking-widest mb-1">
          {breadcrumb || 'TaxnFin · Cashflow Intelligence'}
        </p>
        <h1 className="text-2xl font-bold text-white tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-[#C7CBE3] mt-0.5">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </div>
  );
};

export default PageHeader;
